import { moduleProviderFactory } from 'core/providers';
import { RoleList, RoleEdit } from 'application/role/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.role',
                pattern: '/roles',
                children: [
                    {
                        name: 'master.app.main.role.list',
                        pattern: '',
                        tabTitle: 'ROLE.LIST.TITLE',
                        component: RoleList,
                        authorization: 'administrationSection.read',
                        data: {
                            title: 'ROLE.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.role.create',
                        pattern: '/create',
                        tabTitle: 'Create Role',
                        component: RoleEdit,
                        authorization: 'administrationSection.read',
                        data: {
                            title: 'ROLE.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.role.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Role',
                        component: RoleEdit,
                        authorization: 'administrationSection.read',
                        data: {
                            title: 'ROLE.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.ADMINISTRATION',
                order: 10,
                icon: 'users',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.ROLES',
                        route: 'master.app.main.role.list',
                        order: 3,
                        authorization: 'administrationSection.read',
                    }                    
                ]
            }
        ]
    });
})();

